import { MutationTree } from 'vuex';
import { StatisticState, CustomDetailItem, CustomGroupItem } from './types';

export const mutations: MutationTree<StatisticState> = {
    setCustomStatisticDetail: (state, data: CustomDetailItem[]) => state.customStatisticDetail = data,
    pushCustomStatisticDetail: (state, data: CustomDetailItem[]) => state.customStatisticDetail = state.customStatisticDetail.concat(data),
    setCustomMessagesCount: (state, count: number) => state.customStatisticGroupMessageCount = count,
    setCustomStatisticGroup: (state, data: CustomGroupItem[]) => state.customStatisticGroup = data
};
